import { cn as d } from "../../utils/utils.js";
import * as p from "react";
import { Fragment as n, jsx as e, jsxs as f } from "react/jsx-runtime";
import { Slot as x } from "@radix-ui/react-slot";
import { cva as m } from "class-variance-authority";
var h = "secondary-900 text rounded-none border-none bg-white stroke-primary-600 !p-0 text-primary-600 outline-none hover:stroke-primary-800 hover:text-primary-800 focus-visible:outline-[2px] focus-visible:outline-offset-0 focus-visible:outline-secondary-900 focus-visible:[outline-style:solid] active:stroke-secondary-900 active:text-secondary-900 active:text-secondary-900 disabled:bg-white disabled:stroke-secondary-200 disabled:text-secondary-200 dark:hover:bg-accent/50", l = "w-full rounded-tl-[0px] rounded-tr-[0px] rounded-br-md rounded-bl-md border-0 border-t border-t-secondary-200 bg-white", g = m("inline-flex max-w-full shrink-0 cursor-pointer items-center justify-center gap-2 rounded-[8px] text-center text-base font-semibold whitespace-nowrap shadow-none transition-all outline-none focus-visible:ring-0 disabled:pointer-events-none disabled:bg-secondary-300 disabled:opacity-100 aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 [&>svg]:pointer-events-none [&>svg]:shrink-0 [&>svg]:stroke-white [&>svg:not([class*='size-'])]:size-4", {
  variants: {
    variant: {
      default: "box-border border border-primary-600 bg-primary-600 stroke-white text-white hover:border-primary-700 hover:bg-primary-700 focus-visible:border-secondary-900 focus-visible:outline-[1px] focus-visible:outline-offset-0 focus-visible:outline-secondary-900 focus-visible:[outline-style:solid] active:border-primary-800 active:bg-primary-800 disabled:border-secondary-300 [&>svg]:stroke-white",
      outline: "box-border border border-primary-600 bg-white stroke-primary-600 text-primary-600 hover:border-primary-800 hover:bg-primary-100 hover:stroke-primary-800 hover:text-primary-800 focus-visible:border-secondary-900 focus-visible:outline-[1px] focus-visible:outline-offset-0 focus-visible:outline-secondary-900 focus-visible:[outline-style:solid] active:border-secondary-900 active:stroke-secondary-900 active:text-secondary-900 active:[border:1px_solid_secondary-900] disabled:border-secondary-200 disabled:bg-white disabled:stroke-secondary-200 disabled:text-secondary-200 disabled:opacity-100 dark:border-input dark:bg-input/30 dark:hover:bg-input/50",
      ghost: "secondary-900 text rounded-none border-none bg-white stroke-primary-600 !p-0 text-primary-600 outline-none hover:stroke-primary-800 hover:text-primary-800 focus-visible:outline-[2px] focus-visible:outline-offset-0 focus-visible:outline-secondary-900 focus-visible:[outline-style:solid] active:stroke-secondary-900 active:text-secondary-900 disabled:bg-white disabled:stroke-secondary-200 disabled:text-secondary-200 dark:hover:bg-accent/50",
      link: `${h} bg-transparent underline underline-offset-4 hover:underline`,
      "modal-primary": `${l} text-primary-600 hover:text-primary-800 active:text-secondary-900 disabled:bg-white disabled:text-secondary-200`,
      "modal-secondary": `${l} font-semibold text-secondary-900 active:text-secondary-900 disabled:bg-white disabled:text-secondary-200`,
      input: "box-border rounded-sm border border-secondary-700 bg-white stroke-secondary-600 text-secondary-700 hover:border-secondary-800 hover:bg-secondary-100 hover:stroke-secondary-800 hover:text-secondary-800 focus-visible:border-secondary-900 focus-visible:outline-[1px] focus-visible:outline-offset-0 focus-visible:outline-secondary-900 focus-visible:[outline-style:solid] active:border-secondary-900 active:stroke-secondary-900 active:text-secondary-900 active:[border:1px_solid_secondary-900] disabled:border-secondary-200 disabled:bg-white disabled:stroke-secondary-200 disabled:text-secondary-200 disabled:opacity-100"
    },
    size: {
      default: "px-6 py-4 has-[>svg]:px-3",
      sm: "px-[10px] py-[14px] has-[>svg]:px-2.5",
      lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
      icon: "size-12",
      input: "px-4 pt-1 pb-2"
    }
  },
  defaultVariants: {
    variant: "default",
    size: "default"
  }
});
function _({ className: c, variant: b, size: o, asChild: u = !1, startIcon: t, endIcon: i, title: s, children: r, ...v }) {
  const y = u ? x : "button", a = !!r && !(p.isValidElement(r) && r.props["data-vue-children"] === "");
  return /* @__PURE__ */ e(y, {
    "data-slot": "button",
    className: d(g({
      variant: b,
      size: o
    }), c),
    title: s,
    ...v,
    children: /* @__PURE__ */ f("span", {
      className: d("flex w-full items-center", {
        "gap-2": o !== "icon",
        "justify-center gap-2": o === "icon"
      }),
      children: [
        t && /* @__PURE__ */ e("span", {
          className: "flex h-6 w-6 items-center justify-center [&_path]:stroke-[1.5] [&>svg]:h-6 [&>svg]:w-6 [&>svg]:flex-1",
          children: t
        }),
        a ? /* @__PURE__ */ e("span", {
          className: "w-full flex-1 truncate",
          children: r
        }) : /* @__PURE__ */ e(n, {}),
        !a && s ? /* @__PURE__ */ e("span", {
          className: "w-full flex-1 truncate",
          children: s
        }) : /* @__PURE__ */ e(n, {}),
        i && /* @__PURE__ */ e("span", {
          className: "flex h-6 w-6 items-center justify-center [&_path]:stroke-[1.5] [&>svg]:h-6 [&>svg]:w-6 [&>svg]:flex-1",
          children: i
        })
      ]
    })
  });
}
export {
  _ as Button,
  g as buttonVariants
};

//# sourceMappingURL=button.js.map